import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

// Auth via Bearer token from localStorage. We avoid `withCredentials`
// because the ingress in front of the backend returns
// `Access-Control-Allow-Origin: *`, which browsers reject for
// credentialed cross-origin requests. Bearer tokens work in all cases.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function describeAxiosError(err) {
  const detail = formatApiErrorDetail(err?.response?.data?.detail);
  if (detail) return detail;
  if (err?.response?.status) return `HTTP ${err.response.status}`;
  if (err?.code === "ERR_NETWORK") return "Network error — could not reach server";
  if (err?.message) return err.message;
  return "Something went wrong";
}

export default api;
